import { render, staticRenderFns } from "./BarraConversao.vue?vue&type=template&id=5890e194&scoped=true&lang=pug&"
import script from "./BarraConversao.vue?vue&type=script&lang=js&"
export * from "./BarraConversao.vue?vue&type=script&lang=js&"
import style0 from "./BarraConversao.styl?vue&type=style&index=0&id=5890e194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5890e194",
  null
  
)

export default component.exports